import type { InjectionKey, Ref } from "vue";

import type { Maybe } from "shared/types";

// ModalService mounts exactly one ModalsContainer, so this is safe as an id.
export const MODALS_CONTAINER_ID = "modals-container";

export const MODALS_OVERLAY_TARGET: InjectionKey<Ref<Maybe<HTMLElement>>> =
  Symbol("modalsOverlayTarget");
